import React from 'react';

import { TableRowProps } from './TableRow';

import styles from './TableHead.module.scss';

export interface TableHeadProps
  extends React.HTMLProps<HTMLTableSectionElement> {
  /** Child of `Table.Head` which should be one or more `Table.Row`. */
  children:
    | React.ReactElement<TableRowProps>
    | React.ReactElement<TableRowProps>[];
}

export const TableHead: React.FC<TableHeadProps> = ({ children, ...rest }) => (
  <thead className={styles.head} {...rest}>
    {children}
  </thead>
);

TableHead.displayName = 'Table.Head';
export default TableHead;
